// extracted by mini-css-extract-plugin
export default {"Container":"LastUpdated_Container__NDHxe"};